@if (!investment) {
  <div class="grid-loading-overlay">
    <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
  </div>
}

@if (investment) {
  <div class="row">
    <div class="col-10 top-part">
      @if (!minimizedView) {
        <app-insight-breadcrumbs
          [investment]="investment"
          >
        </app-insight-breadcrumbs>
      }
    </div>
    <!-- <div class="col-2">
    <button nbButton ghost status="primary" class="history-button" (click)="openHistory()">
      <fa-icon icon="clock-rotate-left"></fa-icon>
    </button>
  </div> -->
</div>
}

@if (investment) {
  <div class="row">
    <div class="col-4 sheet">
       <!-- PICTURES -->
      @if (settings.dynamicEl?.length) {
        <nb-card class="info">
          <nb-card-body class="p-0 pictures-container">
            <div class="p-0 main-image" [ngStyle]="{ 'background-image': 'url(' + settings.dynamicEl[0].src + ')' }">
              <lightgallery [settings]="settings" [onInit]="onInit"></lightgallery>
              <button
                nbButton
                class="see-photos"
                status="primary"
                (click)="openGallery()"
              >
                {{ 'theme.see-pictures' | translate }} ({{ settings.dynamicEl.length }})
              </button>
            </div>
          </nb-card-body>
        </nb-card>
      }
      <nb-card class="info">
        <nb-card-body>
          <div class="info-label row">
            <div class="sheet-tag col-12">
              {{'Investment-sheet' | translate}}
            </div>
          </div>
          <div class="location">{{ investment | ngxInvestmentLocation }}</div>
        </nb-card-body>
        <nb-card-body class="p-0">
          <nb-list class="info-list">
            <nb-list-item>
              <div class="name">{{ 'Investment label' | translate }}</div>
              <div class="value"> {{ investment.label }}</div>
            </nb-list-item>
            <!-- Asset label -->
            @if (investment.asset_object) {
              <nb-list-item>
                <div class="name">{{ 'core.utils.spreadsheet_columns.column_asset_label' | translate }}</div>
                <a [routerLink]="['/insight/assets/', investment.asset_object.id]"
                class="value">{{ investment.asset_object.label }}</a>
              </nb-list-item>
            }
            <!-- Budget by year -->
            <nb-list-item>
              <div class="name">{{ 'pages.insight.investment.actual_budget' | translate }}</div>
              <div class="value">{{ budget }} - {{ investment.budget_origin.name }}</div>
            </nb-list-item>
            <!-- Investment status -->
            <nb-list-item>
              <div class="name">{{ 'pages.insight.investment.status' | translate }}</div>
              <div class="value">
                {{ investment.status_object ? investment.status_object.name : '-'  }}
              </div>
            </nb-list-item>

            <!-- SCOPE -->
            <nb-list-item>
              <div class="name">{{ 'Budget scope' | translate }}</div>
              <div class="value">
                {{ scopesString }}
              </div>
            </nb-list-item>

            <!-- Priority -->
            <nb-list-item>
              <div class="name">{{ 'pages.insight.investment.priority' | translate }}</div>
              <div class="value">
                {{ investment.priority_object?.name || '-' }}
              </div>
            </nb-list-item>

            <!-- PROJECT CODE -->
            @if ((customerConfig$ | async)?.show_investment_project_code) {
              <nb-list-item>
                <div class="name">
                  {{ "Project code" | translate }}
                </div>
                <div class="value">
                  {{ investment.project_code || '-' }}
                </div>
              </nb-list-item>
            }

            <!-- See More Button -->
            <nb-list-item class="see-more-container" (click)="seeMoreToggle()">
              @if(!seeMore) {
                <span>
                  {{ 'pages.energy.initiative.labels.more_details' | translate }}
                </span>
              } @else {
                <span>
                  {{ 'pages.energy.initiative.labels.less_details' | translate }}
                </span>
              }
            </nb-list-item>

            <!-- Custom code -->
            @if (seeMore && (customerConfig$ | async)?.show_investment_custom_code) {
              <nb-list-item>
                <div class="name">{{ investmentCodeFieldName }}</div>
                <div class="value">
                  {{ investment.custom_code || '-' }}
                </div>
              </nb-list-item>
            }

            <!-- CAPEX -->
            @if(seeMore) {
              <nb-list-item>
                <div class="name">{{ 'CAPEX' | translate }}</div>
                <div class="value">
                  @if (investment.is_capex) {
                    {{'Yes' | translate }}
                  } @else {
                    {{'No' | translate }}
                  }
                </div>
              </nb-list-item>
            }

            @if(seeMore) {
              <nb-list-item>
                <div class="name">{{ 'CAPEX' | translate }} <span style="text-transform: lowercase;">{{ 'A priori aligned taxonomy' | translate }}</span></div>
                <div class="value">
                  @if (investment?.taxonomy_category || investment?.taxonomy_objective){
                    {{'Yes' | translate }}
                  } @else {
                    {{'No' | translate }}
                  }
                </div>
              </nb-list-item>
            }

            <!-- Sponsors -->
            @if(seeMore) {
              <nb-list-item>
                <div class="name">{{ 'Payers' | translate }}</div>
                <div class="value" [innerHTML]="sponsorsString"></div>
              </nb-list-item>
            }

            <!-- Invoicings -->
            @if(seeMore) {
              <nb-list-item>
                <div class="name">{{ 'pages.common.ag-grid.column_groups.invoice' | translate }}</div>
                <div class="value" >
                  @if (investment?.refacturation === null){
                    {{'quote_part.unknown' | translate }}
                  } @else if(investment?.refacturation === true) {
                    {{'Yes' | translate }}
                  } @else {
                    {{'No' | translate }}
                  }
                </div>
              </nb-list-item>
            }

          </nb-list>
        </nb-card-body>
      </nb-card>
      @if (investment.asset_object || investment.next_asset) {
        <div class="macaron asset">
          <span class="macaron-link" (click)="openLinkedEquipmentDialog()">
            @if (investment.asset_object) {
              {{ "{assetNb} linked asset" | translate : {assetNb : 1} }}
            } @else {
              {{ 'Future equipment' | translate }}
            }
          </span>
          @if (investment.asset_object) {
            <span class="macaron-savings">
              {{ technicalStateLabel }}
            </span>
          }
        </div>
      }
      @if (initiative) {
        <div class="macaron action">
          <span class="macaron-link" (click)="seeInitiative(initiative.id)">
            {{ "{actionNb} linked action" | translate : {actionNb : 1} }}
          </span>
          <span class="macaron-savings">
            @if (getInitiativeSavings() < 0) {
              <span class="up">
                <fa-icon icon="arrow-up-right"></fa-icon>
              </span>
            }
            @if (getInitiativeSavings() > 0) {
              <span class="down">
                <fa-icon icon="arrow-down-right"></fa-icon>
              </span>
            }
            {{ getInitiativeSavings() | number: '1.0-0'}} {{ "kWh" | translate}}
          </span>
        </div>
      }
      @if (docCount > 0) {
        <div class="macaron doc">
          <span class="macaron-link" (click)="seeDocuments()">
            {{ "{count} linked documents" | translate: {count: docCount} }}
          </span>
        </div>
      }
      @if(linkedInvestments$ | async; as linkedInvestments) {
        @if (linkedInvestments.length) {
          <div class="macaron invest">
            <span class="macaron-link" (click)="openLinkedInvestmentsPanel()">
              {{ "{{count}} linked investments" | translate: {count: linkedInvestments.length} }}
            </span>
          </div>
        }
      }

      <!-- Hidden for now -->
      <!-- <app-investment-responsibility-tracker [investmentId]="investment.id" *ngIf="investment"></app-investment-responsibility-tracker> -->
      @if (budgetYear && investment &&
        (investment?.status_object?.is_validated ||
         investment?.status_object?.is_engaged ||
         investment?.status_object?.is_closed
        )) {
        <nb-card class="tabs">
          <nb-card-body>
            <app-budget-monitoring-chart
              [investmentIds]="[investment.id]"
              [boxShadow]="false"
              [budgetYear]="budgetYear"
            ></app-budget-monitoring-chart>
          </nb-card-body>
        </nb-card>
      }
    </div>
    @if (investment) {
      <div
        class="col-8"
        >
        @if (roadmapIndicators.length) {
          <nb-card>
            <nb-card-header class="indicator-header">
              {{ "Investment impact on" | translate }}
            </nb-card-header>
            <nb-card-body class="indicator-body">
              <div class="indicator-container">
                @for (indicator of roadmapIndicators; track indicator) {
                  <div
                    [ngClass]="indicatorInInvest(indicator.id) ? 'indicator-invest' : 'add-border'"
                    class="indicator"
                    >
                    {{ indicator.fullname }}
                  </div>
                }
              </div>
            </nb-card-body>
          </nb-card>
        }
        @if (furtherInformations.length) {
          <nb-card>
            <nb-card-header class="indicator-header">
              {{ "Further information" | translate }}
            </nb-card-header>
            <nb-card-body class="indicator-body">
              <div class="indicator-container">
                @for (info of furtherInformations; track info) {
                  <div
                    [ngClass]="infoInInvest(info.id) ? 'indicator-invest' : 'add-border'"
                    class="indicator"
                    >
                    {{ info.name }}
                  </div>
                }
              </div>
            </nb-card-body>
          </nb-card>
        }
        @if (investment?.comments) {
          <nb-card class="comments">
            <div class="title">{{ 'pages.insight.investment.comments' | translate }}</div>
            <div class="comment-text">
              {{ investment.comments }}
            </div>
          </nb-card>
        }
        @if (investment?.asset_object) {
          <nb-card>
            <h2 class="impact-title">{{ 'pages.insight.investment.impact_on_asset_lifecycle' | translate }}
              <span
                (click)="openAsset(investment.asset_object.id)"
                class="value link"
                >
                {{ investment.asset_object.label }}
              </span>
            </h2>
            @if (!investment?.status_object?.is_cancelled) {
            <app-lifecycle-chart
              [asset]="investment.asset_object"
              [allowZoom]="true"
                [boxShadow]="false"
              ></app-lifecycle-chart>
            }
          </nb-card>
        }
        @if (workflowReasons.length) {
          <nb-card>
            <nb-card-header class="indicator-header">
              {{ "Workflow tags" | translate }}
            </nb-card-header>
            <nb-card-body class="indicator-body">
              <div class="indicator-container">
                @for (reason of workflowReasons; track reason) {
                  <div
                    [ngClass]="reasonInInvest(reason.id) ? '' : 'add-border'"
                    class="indicator"
                    [ngStyle]="{ backgroundColor: reasonInInvest(reason.id) ? reason.background_color : '' }"
                    >
                    {{ reason.name }}
                  </div>
                }
              </div>
            </nb-card-body>
          </nb-card>
        }
        @if (priceSheets.length) {
          <nb-card>
            <div class="impact-title">
              {{ 'Price sheet title' | translate}}
            </div>
            @if ((nextAsset || investment.asset_object) && priceSheets) {
              <app-price-sheets-list
                [priceSheets]="priceSheets"
                [selectedPriceSheetId]="investment.price_sheet"
                [assetType]="nextAsset ? nextAsset.asset_type_object : investment.asset_object.asset_type_object"
                [asset]="nextAsset ? nextAsset : investment.asset"
              ></app-price-sheets-list>
            }
          </nb-card>
        }
        <!-- NEXT ASSET -->
        @if (nextAsset) {
          <div class="row linked-assets">
            <app-next-asset-item [asset]="nextAsset"></app-next-asset-item>
          </div>
        }
      </div>
    }
  </div>
}
